import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const AUSTRALIAN_STATES = ['ACT', 'NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT'];

const StepPersonalInfo = ({ formData, setFormData }) => {
  const update = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Personal Information</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Let's start with the basics. Fields marked with * are required.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        <div className="space-y-2">
          <Label htmlFor="first_name">First Name *</Label>
          <Input
            id="first_name"
            value={formData.first_name || ''}
            onChange={(e) => update('first_name', e.target.value)}
            placeholder="First name"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="last_name">Last Name *</Label>
          <Input
            id="last_name"
            value={formData.last_name || ''}
            onChange={(e) => update('last_name', e.target.value)}
            placeholder="Last name"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="known_as">Known As</Label>
        <Input
          id="known_as"
          value={formData.known_as || ''}
          onChange={(e) => update('known_as', e.target.value)}
          placeholder="Preferred name (optional)"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone">Phone *</Label>
        <Input
          id="phone"
          type="tel"
          value={formData.phone || ''}
          onChange={(e) => update('phone', e.target.value)}
          placeholder="e.g. 0412 345 678"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        <div className="space-y-2">
          <Label htmlFor="location_city">City *</Label>
          <Input
            id="location_city"
            value={formData.location_city || ''}
            onChange={(e) => update('location_city', e.target.value)}
            placeholder="e.g. Canberra"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="location_state">State *</Label>
          <select
            id="location_state"
            value={formData.location_state || ''}
            onChange={(e) => update('location_state', e.target.value)}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <option value="">Select state</option>
            {AUSTRALIAN_STATES.map(state => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="location_country">Country</Label>
        <Input
          id="location_country"
          value={formData.location_country || 'Australia'}
          onChange={(e) => update('location_country', e.target.value)}
          placeholder="Australia"
        />
      </div>
    </div>
  );
};

export default StepPersonalInfo;
